/** Foundation/Anagrafica — M-UX-01: "Copia dal Codice Fiscale" sotto la Partita IVA. */
import React from "react";
import { CopyFromFieldAction } from "@/foundation/ui/CopyFromFieldAction";
import { isTaxCodeVatCompatible } from "./validators";

export function VatFromTaxCodeAction({ taxCode, vat, onCopy, vatRef, testIdPrefix = "vat-from-cf" }) {
  return (
    <CopyFromFieldAction
      sourceValue={taxCode}
      targetValue={vat}
      onCopy={onCopy}
      targetRef={vatRef}
      sourceLabel="Codice Fiscale"
      copiedMessage="Partita IVA compilata dal Codice Fiscale"
      isCompatible={isTaxCodeVatCompatible}
      testIdPrefix={testIdPrefix}
    />
  );
}
